declare var require: any;

import { Component, ElementRef, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import * as HighCharts from 'highcharts';
import { Options } from 'highcharts';
import { IonicPage, MenuController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { IMqttMessage, MqttService } from 'ngx-mqtt';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OPCProvider } from '../../providers/opc/opc';
import CustomPlugin from './hcCustomPlugin';

const NoDataToDsiplay = require('highcharts/modules/no-data-to-display');
NoDataToDsiplay(HighCharts);

const Bullet = require('highcharts/modules/bullet');
Bullet(HighCharts);

const More = require('highcharts/highcharts-more');
More(HighCharts);

const Exporting = require('highcharts/modules/exporting');
Exporting(HighCharts);

const ExportData = require('highcharts/modules/export-data');
ExportData(HighCharts);

const Accessibility = require('highcharts/modules/accessibility');
Accessibility(HighCharts);

CustomPlugin(HighCharts);

@IonicPage()
@Component({
  selector: 'page-dash-detail',
  templateUrl: 'dash-detail.html',
})
export class DashDetailPage {
  loadChart: Chart;
  @ViewChild('loadCanvas') loadCanvas: ElementRef;

  MCDChart: Chart;
  @ViewChild('MCDCanvas') MCDCanvas: ElementRef;

  MPP_SITE: string = '';
  MPP_LOCATION: string = '';
  MPP_COUNT_ENGINE: number = 0;
  MPP_ENGINE_TEXT: string = '';

  _MAXMW: number = 25000 / 1000;

  engine: string;
  TAGS: any = [
    'U1_AI0011',
    'U1_AI0025',
    'U1_AI0033',
    'U1_AI0069',
    'U1_AI0073',
    'U1_AI0077',
    'U1_AI0085',
    'U1_AI0087',
    'U1_AI0089',
    'U1_AI0091',
    'U1_AI0093',
    'U1_AI0095',
    'U1_AI0097',
    'U1_AI0099',
    'U1_AI0101',
    'U1_AI0103',
    'U1_AI0105',
    'U1_AI0107',
    'U1_AI0109',
    'U1_AI0111',
    'U1_AI0113',
    'U1_AI0115',
    'U1_AI0213',
    'U1_AI0214',
    'U1_AI0215',
    'U1_AI0216',
    'U1_AI0217',
    'U1_AI0389',
    'U1_AI0401',
    'U1_AI0402',
    'U1_AI0403',
    'U1_AI0404',
    'U1_AQ7651',
    'U1_AQ7653',
    'U1_AQ7657',
    'U1_I00007',
    'U1_I03647',
    'U1_R05355',
    'U1_R05381',
    'U1_R14007',
    'U1_R14009',
    'U1_R14029',
    'U1_R14031',
    'U1_R14049',
    'U1_R14059',
    'U1_R14069',
    'U1_R14079',
    'U1_R15009',
  ];

  topic: string;

  MQTTSubscriber: any;
  data = {};
  data_last: string;

  LOADSubscriber: any;
  historyLoadData: any;
  graphData: any;

  T48Chart: any;
  NGGAChart: any;
  NGGBChart: any;
  NPTAChart: any;
  NPTBChart: any;
  GenVibChart: any;
  TurVibChart: any;

  MPPCode: string;
  unitNo: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private menuCtrl: MenuController,
    private OPCPrvdr: OPCProvider,
    private mqttSvc: MqttService
  ) {
    this.structuringData();
  }

  ionViewDidLoad() {
    this.menuCtrl.enable(true);
  }

  ionViewWillEnter() {
    this.data = this.navParams.data.data;
    this.data_last = this.navParams.data.data_last;
    this.engine = this.navParams.data.engine;
    this.MPPCode = this.engine.split('TM', 3)[0];
    this.unitNo = this.engine.split('TM', 3)[1];

    this._getMPP(this.MPPCode);

    this.subscribeMQTT();
    this.subscribeLOAD();
  }

  ionViewDidEnter() {
    // Plot chart
    this.plotLoadChart();
    this.plotT48Chart();
    this.plotNPTChart();
    this.plotNGGChart();
    this.plotGenVibChart();
    this.plotTurVibChart();
    this.plotMCDChart();

    // Update chart
    this.updateLoadChart();
    this.updateT48Chart();
    this.updateNGGChart();
    this.updateNPTChart();
    this.updateGenVibChart();
    this.updateTurVibChart();
    this.updateMCDChart();
  }

  ionViewWillLeave() {
    this.MQTTSubscriber.unsubscribe();
    this.LOADSubscriber.unsubscribe();
  }

  ionViewDidLeave() {
    // this.loadChart.clear();
  }

  structuringData() {
    this.data = {};
    this.graphData = {
      WAKTU: [],
      MAX: [],
      MW: [],
      MVAR: [],
    };
    this.TAGS.forEach((tag) => {
      if (tag === 'U1_I00007' || tag === 'U1_I03647') {
        this.data[tag] = '...';
      } else {
        this.data[tag] = 0;
      }
    });
  }

  _getMPP(code) {
    if (code === 'NIA') {
      this.MPP_SITE = 'MPP Gunung Sitoli';
      this.MPP_LOCATION = 'Nias';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '1 x 25 MW';
      this.topic = 'mpp/nias' + this.unitNo;
    } else if (code === 'MDN') {
      this.MPP_SITE = 'MPP Paya Pasir';
      this.MPP_LOCATION = 'Medan';
      this.MPP_COUNT_ENGINE = 2;
      this.MPP_ENGINE_TEXT = '2 x 25 MW';
      this.topic = 'mpp/medan' + this.unitNo;
    } else if (code === 'DUR') {
      this.MPP_SITE = 'MPP Balai Pungut';
      this.MPP_LOCATION = 'Duri';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '3 x 25 MW';
      this.topic = 'mpp/duri' + this.unitNo;
    } else if (code === 'BGK') {
      this.MPP_SITE = 'MPP Air Anyir';
      this.MPP_LOCATION = 'Bangka';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '2 x 25 MW';
      this.topic = 'mpp/bangka' + this.unitNo;
    } else if (code === 'BLT') {
      this.MPP_SITE = 'MPP Suge';
      this.MPP_LOCATION = 'Belitung';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '1 x 25 MW';
      this.topic = 'mpp/belitung' + this.unitNo;
    } else if (code === 'LMP') {
      this.MPP_SITE = 'MPP Tarahan';
      this.MPP_LOCATION = 'Lampung';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '4 x 25 MW';
      this.topic = 'mpp/lampung' + this.unitNo;
    } else if (code === 'PON') {
      this.MPP_SITE = 'MPP Parit Baru';
      this.MPP_LOCATION = 'Pontianak';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '4 x 25 MW';
      this.topic = 'mpp/pontianak' + this.unitNo;
    } else if (code === 'LOM') {
      this.MPP_SITE = 'MPP Jeranjang';
      this.MPP_LOCATION = 'Lombok';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '2 x 25 MW';
      this.topic = 'mpp/lombok' + this.unitNo;
    } else if (code === 'SUP') {
      this.MPP_SITE = 'MPP Suppa';
      this.MPP_LOCATION = 'Makassar';
      this.MPP_COUNT_ENGINE = 1;
      this.MPP_ENGINE_TEXT = '2 x 25 MW';
      this.topic = 'mpp/suppa' + this.unitNo;
    }
  }

  subscribeMQTT() {
    this.MQTTSubscriber = this.mqttSvc.observe(this.topic).subscribe((message: IMqttMessage) => {
      var payload: any = this.binArrayToJson(message.payload);

      payload.forEach((data) => {
        var x_tag = data.id.split('.')[2];

        if (
          x_tag === 'U1_AI0011' ||
          x_tag === 'U1_AI0389' ||
          x_tag === 'U1_AI0213' ||
          x_tag === 'U1_AI0214' ||
          x_tag === 'U1_AI0215' ||
          x_tag === 'U1_AI0216' ||
          x_tag === 'U1_AI0217'
        ) {
          // DIVIDE BY 10
          if (data.v === 0) {
            this.data[x_tag] = data.v.toFixed(2);
          } else {
            this.data[x_tag] = (data.v / 10).toFixed(2);
          }
          // MCD CHART
          if (
            x_tag === 'U1_AI0213' ||
            x_tag === 'U1_AI0214' ||
            x_tag === 'U1_AI0215' ||
            x_tag === 'U1_AI0216' ||
            x_tag === 'U1_AI0217'
          ) {
            //U1_AI0213
            //U1_AI0214
            //U1_AI0215
            //U1_AI0216
            //U1_AI0217
            this.updateMCDChart();
          }
        } else if (x_tag === 'U1_AQ7651' || x_tag === 'U1_AQ7653' || x_tag === 'U1_AQ7657') {
          // DIVIDE BY 1000
          if (data.v === 0) {
            this.data[x_tag] = data.v.toFixed(2);
          } else {
            this.data[x_tag] = (data.v / 1000).toFixed(2);
          }
        } else if (x_tag === 'U1_R05381') {
          // DIVIDE BY 3600
          if (data.v === 0) {
            this.data[x_tag] = data.v.toFixed(2);
          } else {
            this.data[x_tag] = (data.v / 3600).toFixed(2);
          }
        } else if (x_tag === 'U1_I00007') {
          // STATUS CB GENERATOR
          this.data[x_tag] = data.v;
        } else if (x_tag === 'U1_I03647') {
          // FUEL OPERATION MODE
          this.data[x_tag] = data.v;
        } else {
          // NORMAL DATA NO DIVIDE
          if (data.v === 0) {
            this.data[x_tag] = parseFloat(data.v).toFixed(2);
          } else {
            this.data[x_tag] = parseFloat(data.v).toFixed(2);
          }

          // T48 CHART
          if (
            x_tag === 'U1_AI0093' ||
            x_tag === 'U1_AI0095' ||
            x_tag === 'U1_AI0097' ||
            x_tag === 'U1_AI0099' ||
            x_tag === 'U1_AI0101' ||
            x_tag === 'U1_AI0103' ||
            x_tag === 'U1_AI0105' ||
            x_tag === 'U1_AI0107'
          ) {
            this.updateT48Chart();
          }

          // NPT CHART
          if (x_tag === 'U1_AI0113' || x_tag === 'U1_AI0115') {
            this.updateNPTChart();
          }

          // NGG CHART
          if (x_tag === 'U1_AI0109' || x_tag === 'U1_AI0111') {
            this.updateNGGChart();
          }

          // GENERATOR VIBRATION CHART
          if (x_tag === 'U1_R14049' || x_tag === 'U1_R14059' || x_tag === 'U1_R14079' || x_tag === 'U1_R14069') {
            // U1_R14049 GEN DE X
            // U1_R14059 GEN DE Y
            // U1_R14079 GEN NDE Y
            // U1_R14069 GEN NDE X
            this.updateGenVibChart();
          }

          // TURBINE VIBRATION CHART
          if (x_tag === 'U1_R14009' || x_tag === 'U1_R14007' || x_tag === 'U1_R14031' || x_tag === 'U1_R14029') {
            // U1_R14009 PT CRF
            // U1_R14007 GG CRF
            // U1_R14031 PT TRF
            // U1_R14029 GG TRF
            this.updateTurVibChart();
          }
        }

        if (this.data_last === '...' || this.data_last < data.t) this.data_last = data.t;
      });
    });
  }

  subscribeLOAD() {
    this.LOADSubscriber = timer(0, 60000)
      .pipe(switchMap(() => this.OPCPrvdr.getLoadHistory1524(this.engine)))
      .subscribe(async (res: any) => {
        if (res.success === true) {
          this.historyLoadData = res.data;
          this.graphData = {
            WAKTU: [],
            MAX: [],
            MW: [],
            MVAR: [],
          };

          await this.historyLoadData.forEach((data) => {
            this.graphData.MAX.push(25);
            this.graphData.WAKTU.push(moment(data.waktu).format('HH:mm'));
            this.graphData.MW.push(data.mw);
            this.graphData.MVAR.push(data.mvar);
          });
          this.updateLoadChart();
        }
      });
  }

  plotLoadChart() {
    this.loadChart = new Chart(this.loadCanvas.nativeElement, {
      type: 'line',
      options: {
        maintainAspectRatio: false,
        tooltips: { enabled: true },
        animation: false,
        legend: {
          display: true,
          labels: {
            fontSize: 10,
            fontFamily: 'PT Sans Narrow',
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 8,
                fontFamily: 'PT Sans Narrow',
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontSize: 8,
                fontFamily: 'PT Sans Narrow',
              },
            },
          ],
        },
      },
      data: {
        labels: [],
        datasets: [
          {
            label: 'MAX',
            data: [],
            fill: true,
            lineTension: 0,
            backgroundColor: 'rgba(255,171,87,.2)',
            borderColor: 'rgba(255,171,87,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            borderWidth: 1,
            pointBorderColor: 'rgba(255,171,87,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointRadius: 0,
            pointHitRadius: 10,
            spanGaps: false,
            pointHoverBackgroundColor: 'rgba(255,171,87,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointHoverRadius: 6,
          },
          {
            label: 'MW',
            data: [],
            fill: true,
            lineTension: 0.3,
            backgroundColor: 'rgba(54,162,235,.2)',
            borderColor: 'rgba(54,162,235,1)',
            borderCapStyle: 'round',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'round',
            borderWidth: 2,
            pointBorderColor: 'rgba(54,162,235,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 0,
            pointHitRadius: 10,
            spanGaps: false,
            pointHoverBackgroundColor: 'rgba(54,162,235,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointHoverRadius: 6,
          },
          {
            label: 'MVAR',
            data: [],
            fill: true,
            lineTension: 0.3,
            backgroundColor: 'rgba(75,192,192,0.2)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'round',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'round',
            borderWidth: 1,
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointRadius: 0,
            pointHitRadius: 10,
            spanGaps: false,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointHoverRadius: 6,
          },
        ],
      },
    });
  }

  updateLoadChart() {
    if (this.loadChart instanceof Chart) {
      // Removing Data
      this.loadChart.data.labels.pop();
      this.loadChart.data.datasets.forEach((dataset) => {
        dataset.data.pop();
      });
      this.loadChart.update();

      // Updating Data
      this.loadChart.data.labels = this.graphData.WAKTU;
      this.loadChart.data.datasets[0].data = this.graphData.MAX;
      this.loadChart.data.datasets[1].data = this.graphData.MW;
      this.loadChart.data.datasets[2].data = this.graphData.MVAR;
      this.loadChart.update();
    } else {
      this.plotLoadChart();
    }
  }

  plotT48Chart() {
    this.T48Chart = HighCharts.chart('T48Chart', {
      chart: {
        polar: true,
      },
      title: {
        text: null,
      },
      pane: {
        startAngle: 10,
        endAngle: 370,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        tickInterval: 45,
        min: 0,
        max: 360,
        labels: {
          formatter: function () {
            let label;
            switch (this.value) {
              case 0:
                label = 'T48 A';
                break;
              case 45:
                label = 'T48 B';
                break;
              case 90:
                label = 'T48 C';
                break;
              case 135:
                label = 'T48 D';
                break;
              case 180:
                label = 'T48 E';
                break;
              case 225:
                label = 'T48 F';
                break;
              case 270:
                label = 'T48 G';
                break;
              case 315:
                label = 'T48 H';
                break;
            }
            return label;
          },

          style: {
            fontFamily: 'PT Sans Narrow',
            fontSize: '10px',
          },
        },
      },
      yAxis: {
        min: 100,
        max: 1640,
        lineWidth: 1,
        tickInterval: 10,
        visible: false,
      },
      plotOptions: {
        series: {
          pointStart: 337.5,
          pointInterval: 22.5,
        },
        column: {
          color: 'rgba(20, 215, 23, 0.6)',
          pointPadding: 0,
          groupPadding: 0,
        },
      },
      series: [
        {
          type: 'column',
          name: 'T48',
          data: [1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640, 1640],
        },

        {
          type: 'area',
          name: 'Sensor',
          marker: {
            enabled: false,
          },
          color: {
            radialGradient: {
              cx: 0.5,
              cy: 0.5,
              r: 0.6,
            },
            stops: [
              [0, '#3eff00'],
              [0, '#feff00'],
              [0.5, '#ff8000'],
              [0.9, '#ff0000'],
            ],
          },
          data: [],
        },
      ],
    });
  }

  updateT48Chart() {
    // T48A === 'U1_AI0093'
    // T48B === 'U1_AI0095'
    // T48C === 'U1_AI0097'
    // T48D === 'U1_AI0099'
    // T48E === 'U1_AI0101'
    // T48F === 'U1_AI0103'
    // T48G === 'U1_AI0105'
    // T48H === 'U1_AI0107'

    // 'AVERAGE_HA',
    // 'U1_AI0093',
    // 'AVERAGE_AB',
    // 'U1_AI0095',
    // 'AVERAGE_BC',
    // 'U1_AI0097',
    // 'AVERAGE_CD',
    // 'U1_AI0099',
    // 'AVERAGE_DE',
    // 'U1_AI0101',
    // 'U1_AI0103',
    // 'AVERAGE_EF',
    // 'U1_AI0105',
    // 'AVERAGE_FG',
    // 'U1_AI0107',

    let AVERAGE_AB = (parseFloat(this.data['U1_AI0093']) + parseFloat(this.data['U1_AI0095'])) / 2;
    let AVERAGE_BC = (parseFloat(this.data['U1_AI0095']) + parseFloat(this.data['U1_AI0097'])) / 2;
    let AVERAGE_CD = (parseFloat(this.data['U1_AI0097']) + parseFloat(this.data['U1_AI0099'])) / 2;
    let AVERAGE_DE = (parseFloat(this.data['U1_AI0099']) + parseFloat(this.data['U1_AI0101'])) / 2;
    let AVERAGE_EF = (parseFloat(this.data['U1_AI0101']) + parseFloat(this.data['U1_AI0103'])) / 2;
    let AVERAGE_FG = (parseFloat(this.data['U1_AI0103']) + parseFloat(this.data['U1_AI0105'])) / 2;
    let AVERAGE_GH = (parseFloat(this.data['U1_AI0105']) + parseFloat(this.data['U1_AI0107'])) / 2;
    let AVERAGE_HA = (parseFloat(this.data['U1_AI0107']) + parseFloat(this.data['U1_AI0093'])) / 2;

    let sensor_series = [];

    sensor_series.push(AVERAGE_HA);
    sensor_series.push(parseFloat(this.data['U1_AI0093']));
    sensor_series.push(AVERAGE_AB);
    sensor_series.push(parseFloat(this.data['U1_AI0095']));
    sensor_series.push(AVERAGE_BC);
    sensor_series.push(parseFloat(this.data['U1_AI0097']));
    sensor_series.push(AVERAGE_CD);
    sensor_series.push(parseFloat(this.data['U1_AI0099']));
    sensor_series.push(AVERAGE_DE);
    sensor_series.push(parseFloat(this.data['U1_AI0101']));
    sensor_series.push(AVERAGE_EF);
    sensor_series.push(parseFloat(this.data['U1_AI0103']));
    sensor_series.push(AVERAGE_FG);
    sensor_series.push(parseFloat(this.data['U1_AI0105']));
    sensor_series.push(AVERAGE_GH);
    sensor_series.push(parseFloat(this.data['U1_AI0107']));

    if (this.T48Chart) {
      this.T48Chart.series[1].setData(sensor_series);
    }
  }

  plotNPTChart() {
    let optionsNPTA: Options = {
      chart: {
        inverted: true,
        height: 70,
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories: ['<span class="hc-cat-title">NPTA</span><br/> SE-8002A'],
        labels: {
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '8px',
          },
        },
        lineColor: '#C0C0C0',
        tickLength: 0,
      },
      yAxis: {
        min: 0,
        max: 15000,
        tickLength: 4,
        tickWidth: 4,
        tickColor: '#C0C0C0',
        gridLineColor: '#C0C0C0',
        gridLineWidth: 1,
        minorTickInterval: 500,
        minorTickWidth: 1,
        minorTickLength: 4,
        minorGridLineWidth: 0,

        title: null,
        labels: {
          format: '{value}',
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '6px',
          },
        },
        plotBands: [
          {
            from: 0,
            to: 4000,
            color: '#75c363',
          },

          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },
          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },

          {
            from: 7000,
            to: 9000,
            color: '#d4e5d0',
          },
          {
            from: 9000,
            to: 10000,
            color: '#f6f93b',
          },
          {
            from: 10000,
            to: 11000,
            color: '#f9973b',
          },
          {
            from: 11000,
            to: 16000,
            color: '#fb1224',
          },
        ],
      },
      series: [
        {
          type: 'lineargauge',
          data: [0],
          color: '#000000',
          dataLabels: {
            enabled: true,
            align: 'center',
            format: '{point.y} RPM',
          },
        },
      ] as any,
    };

    let optionsNPTB: Options = {
      chart: {
        inverted: true,
        height: 70,
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories: ['<span class="hc-cat-title">NPTB</span><br/> SE-8002B'],
        labels: {
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '8px',
          },
        },
        lineColor: '#C0C0C0',
        tickLength: 0,
      },
      yAxis: {
        min: 0,
        max: 15000,
        tickLength: 4,
        tickWidth: 4,
        tickColor: '#C0C0C0',
        gridLineColor: '#C0C0C0',
        gridLineWidth: 1,
        minorTickInterval: 500,
        minorTickWidth: 1,
        minorTickLength: 4,
        minorGridLineWidth: 0,

        title: null,
        labels: {
          format: '{value}',
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '6px',
          },
        },
        plotBands: [
          {
            from: 0,
            to: 4000,
            color: '#75c363',
          },

          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },
          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },

          {
            from: 7000,
            to: 9000,
            color: '#d4e5d0',
          },
          {
            from: 9000,
            to: 10000,
            color: '#f6f93b',
          },
          {
            from: 10000,
            to: 11000,
            color: '#f9973b',
          },
          {
            from: 11000,
            to: 16000,
            color: '#fb1224',
          },
        ],
      },
      series: [
        {
          type: 'lineargauge',
          data: [0],
          color: '#000000',
          dataLabels: {
            enabled: true,
            align: 'center',
            format: '{point.y} RPM',
          },
        },
      ] as any,
    };

    this.NPTAChart = HighCharts.chart('NPTAChart', optionsNPTA);
    this.NPTBChart = HighCharts.chart('NPTBChart', optionsNPTB);
  }

  updateNPTChart() {
    if (this.NPTAChart) this.NPTAChart.series[0].setData([parseFloat(this.data['U1_AI0113'])]);
    if (this.NPTBChart) this.NPTBChart.series[0].setData([parseFloat(this.data['U1_AI0115'])]);
  }

  plotNGGChart() {
    //

    let optionsNGGA: Options = {
      chart: {
        inverted: true,
        height: 70,
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories: ['<span class="hc-cat-title">NGGA</span><br/> SE-800A'],
        labels: {
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '8px',
          },
        },
        lineColor: '#C0C0C0',
        tickLength: 0,
      },
      yAxis: {
        min: 0,
        max: 15000,
        tickLength: 4,
        tickWidth: 4,
        tickColor: '#C0C0C0',
        gridLineColor: '#C0C0C0',
        gridLineWidth: 1,
        minorTickInterval: 500,
        minorTickWidth: 1,
        minorTickLength: 4,
        minorGridLineWidth: 0,

        title: null,
        labels: {
          format: '{value}',
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '6px',
          },
        },
        plotBands: [
          {
            from: 0,
            to: 4000,
            color: '#75c363',
          },

          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },
          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },

          {
            from: 7000,
            to: 9000,
            color: '#d4e5d0',
          },
          {
            from: 9000,
            to: 10000,
            color: '#f6f93b',
          },
          {
            from: 10000,
            to: 11000,
            color: '#f9973b',
          },
          {
            from: 11000,
            to: 16000,
            color: '#fb1224',
          },
        ],
      },
      series: [
        {
          type: 'lineargauge',
          data: [0],
          color: '#000000',
          dataLabels: {
            enabled: true,
            align: 'center',
            format: '{point.y} RPM',
          },
        },
      ] as any,
    };

    let optionsNGGB: Options = {
      chart: {
        inverted: true,
        height: 70,
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories: ['<span class="hc-cat-title">NGGA</span><br/> SE-800A'],
        labels: {
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '8px',
          },
        },
        lineColor: '#C0C0C0',
        tickLength: 0,
      },
      yAxis: {
        min: 0,
        max: 15000,
        tickLength: 4,
        tickWidth: 4,
        tickColor: '#C0C0C0',
        gridLineColor: '#C0C0C0',
        gridLineWidth: 1,
        minorTickInterval: 500,
        minorTickWidth: 1,
        minorTickLength: 4,
        minorGridLineWidth: 0,

        title: null,
        labels: {
          format: '{value}',
          style: {
            FontFace: 'PT Sans Narrow',
            fontSize: '6px',
          },
        },
        plotBands: [
          {
            from: 0,
            to: 4000,
            color: '#75c363',
          },

          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },
          {
            from: 4000,
            to: 7000,
            color: '#9de08d',
          },

          {
            from: 7000,
            to: 9000,
            color: '#d4e5d0',
          },
          {
            from: 9000,
            to: 10000,
            color: '#f6f93b',
          },
          {
            from: 10000,
            to: 11000,
            color: '#f9973b',
          },
          {
            from: 11000,
            to: 16000,
            color: '#fb1224',
          },
        ],
      },
      series: [
        {
          type: 'lineargauge',
          data: [0],
          color: '#000000',
          dataLabels: {
            enabled: true,
            align: 'center',
            format: '{point.y} RPM',
          },
        },
      ] as any,
    };

    this.NGGAChart = HighCharts.chart('NGGAChart', optionsNGGA);
    this.NGGBChart = HighCharts.chart('NGGBChart', optionsNGGB);
  }

  updateNGGChart() {
    if (this.NGGAChart) this.NGGAChart.series[0].setData([parseFloat(this.data['U1_AI0109'])]);
    if (this.NGGAChart) this.NGGBChart.series[0].setData([parseFloat(this.data['U1_AI0111'])]);
  }

  plotGenVibChart() {
    this.GenVibChart = HighCharts.chart('GenVibChart', {
      chart: {
        polar: true,
      },
      title: {
        text: null,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: ['GEN DE X', 'GEN DE Y', 'GEN NDE Y', 'GEN NDE X'],
        tickmarkPlacement: 'on',
        lineWidth: 0,
      },
      yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
      },
      tooltip: {
        shared: true,
        pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y} Mil</b><br/>',
      },
      series: [
        {
          type: 'area',
          name: 'Vibration Sensor',
          data: [0, 0, 0, 0],
        },
      ],
    });
  }

  updateGenVibChart() {
    // U1_R14049 GEN DE X
    // U1_R14059 GEN DE Y
    // U1_R14079 GEN NDE Y
    // U1_R14069 GEN NDE X
    let dataGen = [];
    dataGen.push(parseFloat(this.data['U1_R14049']));
    dataGen.push(parseFloat(this.data['U1_R14059']));
    dataGen.push(parseFloat(this.data['U1_R14079']));
    dataGen.push(parseFloat(this.data['U1_R14069']));

    if (this.GenVibChart) this.GenVibChart.series[0].setData(dataGen);
  }

  plotTurVibChart() {
    this.TurVibChart = HighCharts.chart('TurVibChart', {
      chart: {
        polar: true,
      },
      title: {
        text: null,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: ['PT CRF', 'GG CRF', 'GG TRF', 'PT TRF'],
        tickmarkPlacement: 'on',
        lineWidth: 0,
      },
      yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
      },
      tooltip: {
        shared: true,
        pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y} Mil</b><br/>',
      },
      series: [
        {
          type: 'area',
          name: 'Vibration Sensor',
          data: [0, 0, 0, 0],
        },
      ],
    });
  }

  updateTurVibChart() {
    // U1_R14009 PT CRF
    // U1_R14007 GG CRF
    // U1_R14031 PT TRF
    // U1_R14029 GG TRF

    let dataTur = [];

    dataTur.push(parseFloat(this.data['U1_R14009']));
    dataTur.push(parseFloat(this.data['U1_R14007']));
    dataTur.push(parseFloat(this.data['U1_R14031']));
    dataTur.push(parseFloat(this.data['U1_R14029']));

    if (this.TurVibChart) this.TurVibChart.series[0].setData(dataTur);
  }

  plotMCDChart() {
    this.MCDChart = new Chart(this.MCDCanvas.nativeElement, {
      type: 'horizontalBar',
      options: {
        maintainAspectRatio: false,
        tooltips: { enabled: true },
        animation: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 12,
                fontFamily: 'PT Sans Narrow',
                fontWeight: 'bold',
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: false,
                fontSize: 12,
                fontFamily: 'PT Sans Narrow',
              },
            },
          ],
        },
      },
      data: {
        labels: ['ACCY GB S', 'A SUMP SC', 'B SUMP SC', 'C SUMP SC', 'D SUMP SC'],
        datasets: [
          {
            barPercentage: 0.9,
            barThickness: 20,
            maxBarThickness: 50,
            minBarLength: 1,
            label: 'MCD',
            data: [0, 0, 0, 0, 0],
            fill: false,
            backgroundColor: ['#9dc8f1', '#9dc8f1', '#9dc8f1', '#9dc8f1', '#9dc8f1'],
            borderColor: [
              'rgb(124, 181, 236)',
              'rgb(124, 181, 236)',
              'rgb(124, 181, 236)',
              'rgb(124, 181, 236)',
              'rgb(124, 181, 236)',
            ],
            borderWidth: 1,
          },
        ],
      },
    });
  }

  updateMCDChart() {
    //U1_AI0213
    //U1_AI0214
    //U1_AI0215
    //U1_AI0216
    //U1_AI0217

    let dataMCD = [];

    dataMCD.push(parseFloat(this.data['U1_AI0213']));
    dataMCD.push(parseFloat(this.data['U1_AI0214']));
    dataMCD.push(parseFloat(this.data['U1_AI0215']));
    dataMCD.push(parseFloat(this.data['U1_AI0216']));
    dataMCD.push(parseFloat(this.data['U1_AI0217']));

    if (this.MCDChart instanceof Chart) {
      this.MCDChart.data.datasets[0].data = dataMCD;
      this.MCDChart.update();
    } else {
      this.plotMCDChart();
    }
  }

  JsonToArray(json) {
    var str = JSON.stringify(json, null, 0);
    var ret = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) {
      ret[i] = str.charCodeAt(i);
    }
    return ret;
  }

  binArrayToJson(binArray) {
    var str = '';
    for (var i = 0; i < binArray.length; i++) {
      str += String.fromCharCode(parseInt(binArray[i]));
    }
    return JSON.parse(str);
  }
}



// WEBPACK FOOTER //
// ./src/pages/dash-detail/dash-detail.ts